module.exports = __webpack_public_path__ + "static/media/logo_WK.82e49840.svg";